import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ProductsService } from 'src/app/services/producto/products.service';

@Component({
  selector: 'app-edit-product',
  templateUrl: './edit-product.component.html',
  styleUrls: ['./edit-product.component.css']
})
export class EditProductComponent implements OnInit {
  
  public materialForm:any;
  public selectedId:any;
  public product:any=[];
  public producto:any=[];

  constructor(private route:ActivatedRoute,private productService:ProductsService) {
    this.materialForm=new FormGroup({
      fecha:new FormControl('',Validators.required),
      producto:new FormControl('',[Validators.required,Validators.minLength(4)]),
      Trazabilidad:new FormControl('',Validators.required),
      plage:new FormControl('',Validators.required),
      sabor:new FormControl('',Validators.required),
      textura:new FormControl('v'),
      color:new FormControl('v'),
      manchas:new FormControl('v'),
      transporte:new FormControl('v'),
      olor:new FormControl('v'),
      pudedumbre:new FormControl('v'),
      depCalidad:new FormControl('v'),
    });
    this.route.params.subscribe(params=>{
      
      this.selectedId=params;
    });
    this.productDetail();
   }

  ngOnInit() {
   
   
  }
 
  productDetail(){
    this.productService.getListProductsId(this.selectedId).subscribe((data:any)=>{
      console.log(data);
      this.product=data.productos[0];
      console.log(this.product);
      this.materialForm=new FormGroup({
        fecha:new FormControl(this.product.fecha,Validators.required),
        producto:new FormControl(this.product.producto,[Validators.required,Validators.minLength(4)]),
        Trazabilidad:new FormControl(this.product.trazabilidad,Validators.required),
        plage:new FormControl(this.product.libre,Validators.required),
        sabor:new FormControl(this.product.sabor,Validators.required),
        textura:new FormControl(this.product.textura),
        color:new FormControl(this.product.color),
        manchas:new FormControl(this.product.manchas),
        transporte:new FormControl(this.product.transporte),
        olor:new FormControl(this.product.olor),
        pudedumbre:new FormControl(this.product.pudedrumbre),
        depCalidad:new FormControl(this.product.dep_calidad),
      });
    },error=>{
      console.log("Error en la aplicacion ",error)
    });
    
  }
  onSubmit(){
    this.producto=[{
      id:this.selectedId,
      fecha:this.materialForm.controls.fecha.value,
      producto:this.materialForm.controls.producto.value,
      Trazabilidad:this.materialForm.controls.Trazabilidad.value,
      plage:this.materialForm.controls.plage.value,
      sabor:this.materialForm.controls.sabor.value,
      textura:this.materialForm.controls.textura.value,
      color:this.materialForm.controls.color.value,
      manchas:this.materialForm.controls.manchas.value,
      transporte:this.materialForm.controls.transporte.value,
      olor:this.materialForm.controls.olor.value,
      pudedumbre:this.materialForm.controls.pudedumbre.value,
      depCalidad:this.materialForm.controls.depCalidad.value,
    }];
    this.productService.updateProduct(this.producto).subscribe(data=>{
      console.log(data);
    },error=>{
      console.error("Error inesperado ",error);
    });
  }
}
